import { useCallback } from 'react';

import Tag from 'components/global/Tag';
import Tooltip from 'components/global/Tooltip';

import * as S from './ChipViewer.styled';

const ChipViewer = ({ value }) => {
	const renderContent = useCallback(() => (
		<S.Container>
			{value?.map((shift) => (
				<Tag variant="disabled" key={shift.start} label={`${shift.start}-${shift.end}`} />
			))}
		</S.Container>
	));

	if (!value || value.length === 0 || value === 'null') return null;
	return (
		<Tooltip placement="bottom-start" title={renderContent()}>
			{renderContent()}
		</Tooltip>
	);
};
export default ChipViewer;
